import { EGlobalSearchTab } from "@frontend-shared/types";
import {
  getAdjacentGlobalSearchTab,
  getGlobalSearchTabs,
} from "@frontend-shared/utils";
import { useCallback, useMemo, useState } from "react";

import type { IUseGlobalSearchTabsResult } from "../types";
import { useGlobalSearchGateResolver } from "./use-global-search-gate-resolver";

// NOTE: NSAI-6853 — the tabs this user is offered and the one in use. The
// palette always opens on ALL (this hook lives in the body, which unmounts on
// close). A tab whose gate closes while it is active falls back to ALL rather
// than leaving the user on a tab that is no longer drawn.
export const useGlobalSearchTabs = (): IUseGlobalSearchTabsResult => {
  const isGateOpen = useGlobalSearchGateResolver({ isEnabled: true });
  const tabs = useMemo(() => getGlobalSearchTabs({ isGateOpen }), [isGateOpen]);
  const [selectedTab, setSelectedTab] = useState(EGlobalSearchTab.ALL);
  const activeTab = tabs.some((definition) => definition.tab === selectedTab)
    ? selectedTab
    : EGlobalSearchTab.ALL;

  const handleSelectAdjacentTab = useCallback(
    (step: 1 | -1): void => {
      setSelectedTab(
        getAdjacentGlobalSearchTab({ tabs, tab: activeTab, step }),
      );
    },
    [tabs, activeTab],
  );

  return {
    tabs,
    activeTab,
    onSelectTab: setSelectedTab,
    onSelectAdjacentTab: handleSelectAdjacentTab,
  };
};
